export const SAMPLE_WA = [
  {
    label: "Olshop Fashion",
    text: `Halo kak mau order ya 🙏
Nama: Budi Santoso
No HP: 081234567890
Alamat: Jl. Merdeka No 45 RT 02/03, Kel. Gambir, Kec. Gambir, Jakarta Pusat, DKI Jakarta 10110
Ekspedisi: J&T Express
Barang: 2x Kaos Polos Cotton L Warna Hitam
Catatan: tolong dibungkus bubble wrap ya`,
  },
  {
    label: "Dropship Elektronik",
    text: `order masuk bos
penerima siti aminah 0858-1122-3344
kirim ke perumahan griya asri blok C2 no 7, cibinong, kab bogor jawa barat 16911
pake sicepat aja
isi: 1 unit powerbank 10000mah + kabel data
COD 150000`,
  },
  {
    label: "Grosir Reseller",
    text: `Nama penerima: Toko Berkah Jaya (a.n. Pak Andi)
HP: 087811223344
Alamat lengkap: Pasar Tanah Abang Blok A Lantai 3 Los 112, Tanah Abang, Jakarta Pusat 10250
Kurir: Shopee Xpress
Pesanan: 1 lusin daster batik motif campur
No pesanan: INV-2024-0098`,
  },
];

export const CSV_HEADERS = ["Nama Penerima", "No HP", "Alamat Lengkap", "Ekspedisi", "Barang", "Catatan", "Kode Pesanan"];

export const CSV_TEMPLATE_ROWS = [
  ["Budi Santoso", "081234567890", "Jl. Merdeka No 45, Gambir, Jakarta Pusat 10110", "J&T Express", "2x Kaos Polos L", "Bubble wrap", "INV-001"],
  ["Siti Aminah", "085811223344", "Griya Asri Blok C2 No 7, Cibinong, Bogor 16911", "SiCepat", "1x Powerbank 10000mah", "", "INV-002"],
];
